import Widget from "./Widget";
import sources from "../config/sources";
import { tmpl } from "../../templates/overviewwidget.js";
import {
  formatNumber,
  formatChange,
  formatFilesize,
  formatChangeStyle,
} from "../helpers/formatters";

export default class Overview extends Widget {
  constructor(feed) {
    super();

    if (!Object.prototype.hasOwnProperty.call(sources, feed)) {
      throw new Error(`Invalid feed: ${feed}`);
    }

    this.datasources = sources[feed];
  }

  init(el) {
    this.div = document.createElement("div");
    this.div.classList.add("sh-widget", "sh-overview-widget", this._theme);
    this.div.innerHTML = tmpl;
    el.replaceWith(this.div);

    this.build();
  }

  build() {
    const data = this.getData(DATA_URL + this.datasources["overview"]["url"]);
    data.then((data) => {
      this.div.querySelector('[data-element="listings-new"]').innerHTML =
        formatNumber(data["new"]["count"]);

      const newchange = this.div.querySelector(
        '[data-element="listings-new-change"]'
      );
      newchange.innerHTML = formatChange(data["new"]["change"]);
      formatChangeStyle(newchange, data["new"]["change"]);

      this.div.querySelector('[data-element="listings-new-date"]').innerHTML =
        data["new"]["desc"];

      this.div.querySelector('[data-element="listings-all"]').innerHTML =
        formatNumber(data["total"]["count"]);

      const allchange = this.div.querySelector(
        '[data-element="listings-all-change"]'
      );
      allchange.innerHTML = formatChange(data["total"]["change"]);
      formatChangeStyle(allchange, data["total"]["change"]);

      this.div.querySelector('[data-element="listings-all-date"]').innerHTML =
        data["total"]["desc"];
      this.div.querySelector('[data-element="listings-ipv4"]').innerHTML =
        formatNumber(data["ipv4"]["count"]);

      const ipv4change = this.div.querySelector(
        '[data-element="listings-ipv4-change"]'
      );
      ipv4change.innerHTML = formatChange(data["ipv4"]["change"]);
      formatChangeStyle(ipv4change, data["ipv4"]["change"]);

      this.div.querySelector('[data-element="listings-ipv6"]').innerHTML =
        formatNumber(data["ipv6"]["count"]);

      const ipv6change = this.div.querySelector(
        '[data-element="listings-ipv6-change"]'
      );
      ipv6change.innerHTML = formatChange(data["ipv6"]["change"]);
      formatChangeStyle(ipv6change, data["ipv6"]["change"]);

      this.div.querySelector('[data-element="listings-filesize"]').innerHTML =
        formatFilesize(data["filesize"]["filesize"]);

      this.activateTooltips();
      this.clearLoading();
    });
  }
}
